module.exports = __webpack_public_path__ + "img/orange_123.7ef7a377.png";